<template>
  <div id="app">
    <router-view/>

    <!-- Video vrapper -->
    <div :class="['vd-wrapper', {'hide-wrapper': hideWrapper}]">
      <transition name="showvidback">
        <div v-show="animateVideo" class="vd-backdrop" v-touch:tap="closeVid"></div>
      </transition>

      <transition name="showvid"
                  v-on:after-leave="doHideWrapper"
                  v-on:after-enter="playIfLoaded"
      >
        <div v-show="animateVideo" class="vd-video">
          <div class="close-vid" v-touch:tap="closeVid">
            <div class="icon red-cross"></div>
          </div>
          <!--<video-player ref="vidplayer" v-show="(currVideoID !== '')" :videoID="currVideoID"></video-player>-->
          <!-- youtube clips -->
          <div v-show="(currentVid === 'dementia')" id="dementiaVideoID">
            <youtube
              :video-id="dementiaVideoID"
              :player-vars="playerVars"
              ref="youtubeDementia"
              @ended="onCloseVid"
              width="100%"
            ></youtube>
          </div>
          <div v-show="(currentVid === 'improvements')"  id="improvementsVideoID">
            <youtube
              :video-id="improvementVideoID"
              :player-vars="playerVars"
              ref="youtubeImprovements"
              @ended="onCloseVid"
              width="100%"
            ></youtube>
          </div>
          <div v-show="(currentVid === 'individual1')"  id="individualLevel1VideoID">
            <youtube
              :video-id="individualLevel1VideoID"
              :player-vars="playerVars"
              ref="youtubeIndividual1"
              @ended="onCloseVid"
              width="100%"
            ></youtube>
          </div>
          <div v-show="(currentVid === 'individual2')"  id="individualLevel2VideoID">
            <youtube
              :video-id="individualLevel2VideoID"
              :player-vars="playerVars"
              ref="youtubeIndividual2"
              @ended="onCloseVid"
              width="100%"
            ></youtube>
          </div>
          <div v-show="(currentVid === 'unit1')"  id="unit1VideoID">
            <youtube
              :video-id="unit1VideoID"
              :player-vars="playerVars"
              ref="youtubeUnit1"
              @ended="onCloseVid"
              width="100%"
            ></youtube>
          </div>
          <div v-show="(currentVid === 'unit2')"  id="unit2VideoID">
            <youtube
              :video-id="unit2VideoID"
              :player-vars="playerVars"
              ref="youtubeUnit2"
              @ended="onCloseVid"
              width="100%"
            ></youtube>
          </div>
          <div v-show="(currentVid === 'kommun1')"  id="kommun1VideoID">
            <youtube
              :video-id="kommun1VideoID"
              :player-vars="playerVars"
              ref="youtubeKommun1"
              @ended="onCloseVid"
              width="100%"
            ></youtube>
          </div>
          <div v-show="(currentVid === 'kommun2')"  id="kommun2VideoID">
            <youtube
              :video-id="kommun2VideoID"
              :player-vars="playerVars"
              ref="youtubeKommun2"
              @ended="onCloseVid"
              width="100%"
            ></youtube>
          </div>
        </div>
      </transition>
    </div>

    <div :class="['to-small-wrapper', {'displayed': infoDisplayed}]">
      <div class="ts-bd"></div>
      <div class="ts-modal">
        <div class="close-info" v-touch:tap="closeInfo">
          <div class="icon red-cross"></div>
        </div>
        <div class="content" v-html="$lang.to_small_content"></div>
      </div>
    </div>

  </div>
</template>

<script>
// import Video from './components/video-player/'

export default {
  name: 'App',
  data () {
    return {
      desktopSize: false,
      showVideo: false,
      animateVideo: false,
      hideWrapper: true,
      // currVideoID: '273492342',
      currentVid: '',
      playingImprovements: false,
      playingDementia: false,
      dementiaVideoID: 'Fv0sDR1KmqU',
      improvementVideoID: 'GFrk_NCLKWs',
      individualLevel1VideoID: 'nB3xl_UXLzw',
      individualLevel2VideoID: 'ah2xt40jWpE',
      unit1VideoID: '4JvpLpk27Xw',
      unit2VideoID: '53jT4-jDuFM',
      kommun1VideoID: 'fGak3p42OS8',
      kommun2VideoID: 'JZhVTq8YZeI',
      probMobile: false,
      infoDisplayed: false,
      localKey: 'displayed-info',
      isFull: false,
      playerVars: {
        width: '100%',
        rel: 0
      }
    }
  },
  computed: {
    playerDementia () {
      return this.$refs.youtubeDementia.player
    },
    playerImprovement () {
      return this.$refs.youtubeImprovements.player
    },
    playerIndividual1 () {
      return this.$refs.youtubeIndividual1.player
    },
    playerIndividual2 () {
      return this.$refs.youtubeIndividual2.player
    },
    playerUnit1 () {
      return this.$refs.youtubeUnit1.player
    },
    playerUnit2 () {
      return this.$refs.youtubeUnit2.player
    },
    playerKommun1 () {
      return this.$refs.youtubeKommun1.player
    },
    playerKommun2 () {
      return this.$refs.youtubeKommun2.player
    }
  },
  beforeMount () {
    this.infoDisplayed = (localStorage.getItem(this.localKey) !== null)
  },
  mounted () {
    let self = this

    this.$bus.$on('VIDEO.PLAYVIDEO', data => {
      // self.currVideoID = data.videoid
      self.currentVid = data.videoid
      self.$nextTick(function () {
        self.showVid(data.videoid)
      })
    })

    this.$bus.$on('VIDEO.VIDEODONE', () => {
      self.$nextTick(function () {
        self.onCloseVid()
      })
    })
  },
  methods: {
    showVid (id) {
      this.showVideo = true
      this.hideWrapper = false
      this.animateVideo = true

      console.log('this.currentVid', this.currentVid)

      this.playVid()

      /**
      if (self.currentVid === 'dementia') {
        this.playerDementia.playVideo()
      }

      if (self.currentVid === 'improvements') {
        this.playerImprovement.playVideo()
      }
       **/
    },
    closeVid () {
      let self = this
      return self.onCloseVid()
    },
    onCloseVid () {
      if (!this.isFullScreen()) {
        this.showVideo = false
        this.animateVideo = false
      }
      if (this.currentVid === 'dementia') {
        this.playerDementia.pauseVideo()
      }
      if (this.currentVid === 'improvements') {
        this.playerImprovement.pauseVideo()
      }
      if (this.currentVid === 'individual1') {
        this.playerIndividual1.pauseVideo()
      }
      if (this.currentVid === 'individual2') {
        this.playerIndividual2.pauseVideo()
      }
      if (this.currentVid === 'unit1') {
        this.playerUnit1.pauseVideo()
      }
      if (this.currentVid === 'unit2') {
        this.playerUnit2.pauseVideo()
      }
      if (this.currentVid === 'kommun1') {
        this.playerKommun1.pauseVideo()
      }
      if (this.currentVid === 'kommun2') {
        this.playerKommun2.pauseVideo()
      }
    },
    async playVid () {
      if (this.currentVid === 'dementia') {
        await this.playerDementia.playVideo()
      }
      if (this.currentVid === 'improvements') {
        await this.playerImprovement.playVideo()
      }
      if (this.currentVid === 'individual1') {
        await this.playerIndividual1.playVideo()
      }
      if (this.currentVid === 'individual2') {
        await this.playerIndividual2.playVideo()
      }
      if (this.currentVid === 'unit1') {
        await this.playerUnit1.playVideo()
      }
      if (this.currentVid === 'unit2') {
        await this.playerUnit2.playVideo()
      }
      if (this.currentVid === 'kommun1') {
        await this.playerKommun1.playVideo()
      }
      if (this.currentVid === 'kommun2') {
        await this.playerKommun2.playVideo()
      }
    },
    /**
    isFullScreenWindow () {
      let vidFrame = null
      if (this.currentVid === 'dementia') {
        vidFrame = document.getElementById('dementiaVideoID').getElementsByTagName('iFrame')[0]
      } else if (this.currentVid === 'improvements') {
        vidFrame = document.getElementById('improvementsVideoID').getElementsByTagName('iFrame')[0]
      }

      if (vidFrame !== null && vidFrame !== undefined) {
        return ((vidFrame.offsetHeight - 30) <= window.innerHeight)
      } else {
        return false
      }
    },
     **/
    isFullScreen () {
      let vidFrame = null
      if (this.currentVid === 'dementia') {
        vidFrame = document.getElementById('dementiaVideoID').getElementsByTagName('iFrame')[0]
      } else if (this.currentVid === 'improvements') {
        vidFrame = document.getElementById('improvementsVideoID').getElementsByTagName('iFrame')[0]
      } else if (this.currentVid === 'individual1') {
        vidFrame = document.getElementById('individualLevel1VideoID').getElementsByTagName('iFrame')[0]
      } else if (this.currentVid === 'individual2') {
        vidFrame = document.getElementById('individualLevel2VideoID').getElementsByTagName('iFrame')[0]
      } else if (this.currentVid === 'unit1') {
        vidFrame = document.getElementById('unit1VideoID').getElementsByTagName('iFrame')[0]
      } else if (this.currentVid === 'unit2') {
        vidFrame = document.getElementById('unit2VideoID').getElementsByTagName('iFrame')[0]
      } else if (this.currentVid === 'kommun1') {
        vidFrame = document.getElementById('kommun1VideoID').getElementsByTagName('iFrame')[0]
      } else if (this.currentVid === 'kommun2') {
        vidFrame = document.getElementById('kommun2VideoID').getElementsByTagName('iFrame')[0]
      }

      if (vidFrame !== undefined) {
        let frameDim = {width: vidFrame.offsetWidth, height: vidFrame.offsetHeight}
        let windDim = {width: window.innerWidth, height: window.innerHeight}

        if ((frameDim.width > 640 || frameDim.height > 400) || (
          frameDim.width === windDim.width &&
          frameDim.height === windDim.height
        )) {
          console.log('Is prob full screen')
          return true
        } else {
          console.log('Is prob NOT full screen')
          return false
        }
      } else {
        return false
      }
    },
    closeInfo () {
      let self = this
      return self.onCloseInfo()
    },
    onCloseInfo () {
      this.infoDisplayed = true
      if (localStorage !== undefined) {
        localStorage.setItem(this.localKey, true)
      }
    },
    playIfLoaded () {
      let self = this
      return self.onPlayIfLoaded()
    },
    onPlayIfLoaded () {
      /**
      if (this.$refs.vidplayer.playerReady) {
        this.$refs.vidplayer.play()
      }

      if (self.currentVid === 'dementia') {
        this.playerDementia.playVideo()
      }
      this.playerDementia.playVideo()
       **/
    },
    doHideWrapper () {
      this.hideWrapper = true
    }
  },
  components: {
    // 'video-player': Video
  }
}
</script>

<style lang="less">
  @import './assets/css/build.less';
</style>



// WEBPACK FOOTER //
// src/App.vue